export enum PaymentProfile {
  C = 'C',
  P = 'P',
  Variable = 'V',
}
